import { Box } from '@mui/material';
import React from 'react';
import InputCustom from '../InputCustom/InputCustom';

export default function MaskEdit({ form }) {
  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '70px 1fr', gap: 1 }}>
      <InputCustom format={'+###'} isNumber form={form} name={'code'} required={true} placeholder={'+000'} noLimit />
      <InputCustom
        helperText={
          <>
            Форма для телефона - допустимы символы: 0 - это любое число при вводе, () - скобки, - тире и пробел. <br />
            Пример: (000) 000-00-00
          </>
        }
        form={form}
        name={'mask'}
        required={true}
        onChange={(val) => {
          return val.replace(/[^0\-\s()]/g, '');
        }}
      />
    </Box>
  );
}
